const state = {
  /**
   * 当前时间戳
   */
  nowTime: Date.now(),
  pageInit: false,
  pageLoading: false,
  /**
   * 是否为蜘蛛爬虫
   */
  isRobot: /headlesschrome|spider|bot|crawler|slurp/i.test(navigator.userAgent.toLowerCase()),
  /**
   * 是否为移动端
   */
  // isMobile: /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(navigator.userAgent.toLowerCase()),
  isMobile: true,
  /**
   * 是否已滚到底部
   */
  isBottom: false,
  /**
   * 登录的用户
   */
  loginUser: null,
  /**
   * 是否在文章详情页
   */
  isArticlePage: false,
  /**
   * layout 导航
   */
  layoutNav: {
    notice: {},
    header: [],
    footer: [],
    bus: []
  },
  /**
   * 下线通知 弹框的状态
   */
  offlineModalStatus: false,
  /**
   * 手机区号列表
   */
  phoneList: [],
  /**
   * 活动报名状态
   * 0 未报名
   * 1 表单提交成功
   */
  activityStatus: 0,
  pageAction: null,
  globalLayers: []
}

export default state
